import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { const_var } from "../../redux/reducers/reducer";

class CommonPromptBox extends React.Component {
  constructor(props) {
    super(props);
  }
  handleClick = (e) => {
    this.props.handleClose(e);
  };
  render() {
    const { cancelBtnText = "Cancel", deleteBtnText = "Delete" } = this.props;
    return (
      <div>
        <Modal
          centered
          show={this.props.show}
          dialogClassName="new-alert-modal react-modal"
          backdrop="static"
          backdropClassName={`${this.props.backdropclass}`}
          keyboard={false}
          onHide={this.handleClick}
        >
          <button className="close" id="close-btn" onClick={this.handleClick}>
            <span className="icon-close"></span>
          </button>
          <Modal.Body>
            <h5 className="modal-title">
              {this.props.alerttitle != undefined
                ? `${this.props.alerttitle}`
                : (const_var.leadCreatedSuccessfully && const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' ? "All Set!" : "Alert")}
            </h5>
            <div className="row">
              <div className="col-12">
                <p>{this.props.message} {const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' ? <><br/> Thank you.</> : ""}</p>
                {this.props.imagedelete != undefined ? (
                  <div className="imagedelete">
                    <img
                      src={this.props.imagedelete}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="alert-footer">
              {this.props.withtwoaction != undefined ? (
                <>
                  <button
                    onClick={this.handleClick}
                    className="btn btn-default"
                  >
                    <span className="text ">{cancelBtnText}</span>
                  </button>
                  <button
                    onClick={this.handleClick}
                    className="btn btn-primary"
                  >
                    <span className="text">{deleteBtnText}</span>
                  </button>
                </>
              ) : (
                <a
                  className="btn btn-primary"
                  onClick={this.handleClick}
                >
                  <span className="text">Done</span>
                </a>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default connect()(CommonPromptBox);
